// src/pages/Contact.jsx

import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { Email } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function Contact() {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom>
          Contact Us <Email fontSize="large" />
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ mb: 4 }}>
          For any questions or concerns, please email us at <strong>help@mmai.live</strong>
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Button variant="contained" color="primary" component={Link} to="/privacy" sx={{ mx: 1 }}>
            Privacy Policy
          </Button>
          <Button variant="contained" color="primary" component={Link} to="/terms" sx={{ mx: 1 }}>
            Terms & Conditions
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default Contact;
